import { __makeTemplateObject } from "tslib";
import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { Popper } from '@material-ui/core';
import { Paper } from '../Paper/Paper';
import { TimeNumberList } from './TimeNumberList';
import { getNumbers, isHourType, isMinuteType } from './utils';
import { highlightNumber, selectHour, selectMinute, selectSelectorTimeType, } from './reducer/actions';
import { getFixedSpacing } from '../../theme/Spacing/Spacing';
export var TimeSelectPanel = function (_a) {
    var anchorRef = _a.anchorRef, id = _a.id, optionIdBase = _a.optionIdBase, minTimeObj = _a.minTimeObj, maxTimeObj = _a.maxTimeObj, minuteSteps = _a.minuteSteps, state = _a.state, dispatch = _a.dispatch;
    var currentSelectorTimeType = state.currentSelectorTimeType, highlightedHour = state.highlightedHour, highlightedMinute = state.highlightedMinute, selectedHour = state.selectedHour, selectedMinute = state.selectedMinute;
    var closeList = useCallback(function () {
        dispatch(selectSelectorTimeType(undefined));
    }, []);
    var selectNumberHandler = useCallback(function (number) {
        if (isHourType(currentSelectorTimeType)) {
            dispatch(selectHour(number));
            dispatch(selectSelectorTimeType('minute'));
        }
        else if (isMinuteType(currentSelectorTimeType)) {
            dispatch(selectMinute(number));
            dispatch(selectSelectorTimeType(undefined));
        }
    }, [currentSelectorTimeType]);
    var highlightHandler = useCallback(function (number) {
        dispatch(highlightNumber(number));
    }, []);
    // /* List of hours and minutes to display as options. */
    var timeNumbers = useMemo(function () {
        var hours = getNumbers({
            timeType: 'hour',
            minNumber: minTimeObj && minTimeObj.hour,
            maxNumber: maxTimeObj && maxTimeObj.hour,
        });
        var minutes = getNumbers({
            timeType: 'minute',
            steps: minuteSteps,
            minNumber: minTimeObj && minTimeObj.hour === selectedHour
                ? minTimeObj.minute
                : undefined,
            maxNumber: maxTimeObj && maxTimeObj.hour === selectedHour
                ? maxTimeObj.minute
                : undefined,
        });
        return { hours: hours, minutes: minutes };
    }, [minTimeObj, maxTimeObj, minuteSteps, selectedHour]);
    function renderHours() {
        return (React.createElement(TimeNumberList, { timeNumbers: timeNumbers.hours, timeType: "hour", highlightedNumber: highlightedHour, selectedNumber: selectedHour, passiveNumber: selectedMinute, optionIdBase: optionIdBase, onHighlight: highlightHandler, onSelect: selectNumberHandler, onCloseList: closeList }));
    }
    function renderMinutes() {
        return (React.createElement(TimeNumberList, { timeNumbers: timeNumbers.minutes, timeType: "minute", highlightedNumber: highlightedMinute, selectedNumber: selectedMinute, passiveNumber: selectedHour, optionIdBase: optionIdBase, onHighlight: highlightHandler, onSelect: selectNumberHandler, onCloseList: closeList }));
    }
    return (React.createElement(SPopper, { anchorEl: anchorRef.current, id: id, role: "listbox", "aria-label": isHourType(currentSelectorTimeType) ? 'hours' : 'minutes', tabIndex: -1 },
        React.createElement(Paper, null,
            isHourType(currentSelectorTimeType) && renderHours(),
            isMinuteType(currentSelectorTimeType) && renderMinutes())));
};
var SPopper = styled(Popper).attrs({
    disablePortal: true,
    placement: 'bottom',
    open: true,
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 1;\n  width: 100%;\n  padding-top: ", "px;\n"], ["\n  z-index: 1;\n  width: 100%;\n  padding-top: ", "px;\n"])), getFixedSpacing(0.5));
var templateObject_1;
//# sourceMappingURL=TimeSelectPanel.js.map